import axios from "axios";
let baseURL = process.env.VUE_APP_CD_API;
const services = axios.create({
  baseURL,
  timeout: 1000 * 10 * 6,
});
services.interceptors.response.use(
  (response) => {
    const res = response.data;
    return res;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default services;
